import React, { forwardRef } from 'react';

import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { GroupedAddon } from './GroupedAddon';

export const GroupTitledInputText = forwardRef((props, ref) => {
  const {
    title = '',
    value,
    onChange,
    readOnly = false,
    suffix = null,
    className = '',
    onKeyDown,
    onFocus,
    classNameProps,
    variant,
    placeholder,
    disabled,
  } = props;

  return (
    <div className="p-inputgroup h-full">
      <GroupedAddon
        title={title}
        variant={variant}
        classNameProps={classNameProps}
      />
      <InputText
        placeholder={placeholder}
        ref={ref}
        className={classNames(
          className,
          readOnly && (className === '' ? 'bg-gray-100' : className)
        )}
        disabled={disabled}
        readOnly={readOnly}
        value={suffix ? `${value} ${suffix}` : value}
        onChange={onChange && ((e) => onChange(e))}
        onKeyDown={onKeyDown && ((e) => onKeyDown(e))}
        onFocus={onFocus && ((e) => onFocus(e))}
      />
    </div>
  );
});

GroupTitledInputText.displayName = 'GroupTitledInputText';
